<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <div class="form-container">
    <ng-template formHost></ng-template>
  </div>

  <div class="spacer"></div>

  <button (click)="onSave()" color="primary" mat-button mat-raised-button>Save</button>

</page-content>

